import clsx from 'clsx'
import {omit} from 'lodash'
import {subdomainLink, viewerGuard, pdfPreviewLink} from '../../../helpers/url'
import React from 'react'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../context'
import Icon from '../../icon'

function LessonLink (props) {
  const {key, show, to} = props
  const linkProps = omit(props, ['key', 'show'])
  const LinkElem = to
    ? Link
    : ({children}) => (<a {...{...linkProps, ...viewerGuard(linkProps)}}>{children}</a>)
  return (
  <div key={key} className={clsx(key, 'link')}>
    {show && <LinkElem {...linkProps}>
      <Icon name={key} />
    </LinkElem>}
    {!show &&
      <span className="disabled link">
        <Icon name={key} />
      </span>
    }
  </div>)
}

export default function LessonLinks (props) {
  const {id, hasEpl, hasSummary, hasKey} = props
  return (<Consumer>{ context => {
    const {translations, languageId, profile} = context
    const {limited} = profile.institution
    const tooltipTitle = (name) => `${translations[`${name}_tooltip_title`][languageId]}: ${id}`
    const links = [
      { key: 'preview',
        title: tooltipTitle('preview'),
        show: hasEpl,
        href: subdomainLink('preview', '#', languageId, 'lesson', id),
        target: "_blank"
      },
      { key: 'summary',
        title: tooltipTitle('summary'),
        show: hasSummary,
        href: pdfPreviewLink('download','summary', languageId, id),
        target: "_blank"},
      { key: 'key',
        title: tooltipTitle('key'),
        show: hasKey && !limited,
        href: pdfPreviewLink('download', 'key', languageId, id),
        target: "_blank"}
    ]
    return (
      <div className="links">
        {links.map(LessonLink)}
      </div>
    )
  }}</Consumer>)
}
